import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import Authentication from './pages/authentication';
import SearchResults from './pages/search-results';
import BookingFlow from './pages/booking-flow';
import TourDetail from './pages/tour-detail';
import UserDashboard from './pages/user-dashboard';
import Homepage from './pages/homepage';
import PaymentCheckout from './pages/payment-checkout';
import ProfileManagement from './pages/profile-management';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Authentication />} />
        <Route path="/authentication" element={<Authentication />} />
        <Route path="/search-results" element={<SearchResults />} />
        <Route path="/booking-flow" element={<BookingFlow />} />
        <Route path="/tour-detail" element={<TourDetail />} />
        <Route path="/user-dashboard" element={<UserDashboard />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="/payment-checkout" element={<PaymentCheckout />} />
        <Route path="/profile-management" element={<ProfileManagement />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;